import { pxToRem } from "@/util";
import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Image from "next/image";
import { AppColors } from "@/assets/colors";
type props = {
  isReverse: boolean;
  name: string;
  desc: string;
  img: string;
};
export default function ServiceCard({
  isReverse,
  name,
  desc,
  img,
}: Partial<props>) {
  const { classes } = styles();
  return (
    <Paper
      elevation={2}
      className={`${classes.container}`}
      sx={{ flexDirection: isReverse ? "column-reverse" : "column" }}
    >
      <Box className={classes.head}>
        <Typography className={classes.hdTxt}>{name}</Typography>
        <Typography className={classes.descTxt}>{desc}</Typography>
      </Box>
      <Box className={classes.subCont}>
        <Box className={classes.imgCont}>
          <Image src={img || ""} fill alt="real estate" objectFit="cover" />
        </Box>
      </Box>
    </Paper>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    height: pxToRem(425),
    width: "100%",
    padding: theme.spacing(3),
    display: "flex",
    borderRadius: pxToRem(16),
    gap: theme.spacing(3),
    marginBottom: pxToRem(20),
    [theme.breakpoints.down("sm")]: {
      marginBottom: pxToRem(0),
    },
  },
  subCont: {
    flex: 3,
    display: "flex",
    flexDirection: "row",
  },
  head: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    // marginBottom: pxToRem(-40),
  },
  imgCont: {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    borderRadius: pxToRem(8),
    overflow: "hidden",
    // border: `1px solid ${AppColors.neutral["20"]}`,
  },
  hdTxt: {
    fontWeight: 600,
    fontSize: pxToRem(20),
    lineHeight: "160%", // or any responsive height
    fontFamily: "General sans",
    color: AppColors.primary["600"],
    letterSpacing: "0%",
    [theme.breakpoints.down("sm")]: {
      width: "70%",
      fontSize: pxToRem(19),
    },
  },
  descTxt: {
    color: AppColors.text.second,
    fontWeight: 500,
    fontSize: pxToRem(16),
    lineHeight: "160%",
    width: "80%",
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(15),
      width: "100%",
    },
  },
}));
